import React from 'react';
import { FlexRow, LargeText } from '@guryou/html-components';

const NotFound = () => {
  return (
    <FlexRow alignItems="center" justifyContent="center" height="100vh">
      <LargeText color="white">Oops, page doesn't exist</LargeText>
    </FlexRow>
  );
};

export default NotFound;
